export enum UserSegmentType {
  Anonymous = 'anonymous',
  Prospect = 'prospect',
  Normal = 'normal',
  PendingChurn = 'pending-churn',
  Dunning = 'dunning',
  Churned = 'churned',
}

export interface UserSegment {
  id: string;
  name: UserSegmentType;
}
